export default "__VITE_PUBLIC_ASSET__84a42721__"